export default connect => ({
  connectDropTarget: connect.dropTarget()
})




// WEBPACK FOOTER //
// ./src/connectDropTarget.js